[
    {
        "root": {
            "label": "[en]About Us[/en][ja]J-Node について[/ja]",
            "link": ""
        },
        "nodes": [
            {
                "label": "[en]INCF[/en][ja]ニューロインフォマティクス国際統合機構 INCF[/ja]",
                "link": "\/aboutus\/incf.html"
            },
            {
                "label": "[en]INCF Japan Node[/en][ja]INCF 日本ノード[/ja]",
                "link": "\/aboutus\/incf.html"
            },
            {
                "label": "[en]Join Us[/en][ja]参加方法[/ja]",
                "link": "\/joinus\/"
            },
            {
                "label": "[en]History[/en][ja]沿革[/ja]",
                "link": "\/aboutus\/history.html"
            }
        ]
    },
    {
        "root": {
            "label": "[en]News[/en][ja]ニュース[/ja]",
            "link": "\/news\/"
        },
        "nodes": [
            {
                "label": "[en]J-Node Update[/en][ja]J-Nodeサイトの更新情報[/ja]",
                "link": "\/news\/index.php?storytopic=5"
            },
            {
                "label": "[en]Topics/Article[/en][ja]トピックス[/ja]",
                "link": "\/news\/index.php?storytopic=2"
            },
            {
                "label": "[en]Newsletters[/en][ja]ニュースレター[/ja]",
                "link": "\/news\/index.php?storytopic=4"
            },
            {
                "label": "[en]From J-Node Secretariat[/en][ja]事務局からのお知らせ[/ja]",
                "link": "\/news\/index.php?storytopic=7"
            },
            {
                "label": "[en]Meeting/Event[/en][ja]会議／イベント[/ja]",
                "link": "\/news\/index.php?storytopic=3"
            }
        ]
    },
    {
        "root": {
            "label": "[en]Resources[/en][ja]リソース[/ja]",
            "link": ""
        },
        "nodes": [
            {
                "label": "[en]J-Node Platform[/en][ja]日本ノードプラットフォーム[/ja]",
                "link": "\/resource\/platform.html"
            },
            {
                "label": "[en]Across Platform Resource Search[/en][ja]日本ノードプラットフォーム横断検索[/ja]",
                "link": "\/modules\/xsearch\/"
            },
            {
                "label": "[en]Platform Updates[/en][ja]プラットフォーム更新情報[/ja]",
                "link": "\/resource\/platform.html#link-pf-update"
            },
            {
                "label": "[en]Infrastructure Software[/en][ja]基盤ソフトウェア[/ja]",
                "link": "\/resource\/software.html"
            },
            {
                "label": "[en]Related Link[/en][ja]関連リンク[/ja]",
                "link": "\/link\/"
            }
        ]
    },
    {
        "root": {
            "label": "[en]Publication[/en][ja]出版物・刊行物[/ja]",
            "link": "\/publication\/"
        },
        "nodes": [
            {
                "label": "Advances in Neuroinformatics",
                "link": "\/publication\/#aini"
            },
            {
                "label": "[en]J-Node Guidance[/en][ja]日本ノード 紹介資料[/ja]",
                "link": "\/publication\/#brochure"
            },
            {
                "label": "[en]Platform Posters[/en][ja]プラットフォーム ポスター[/ja]",
                "link": "\/publication\/#pfposter"
            }
        ]
    },
    {
        "root": {
            "label": "[en]Tutorial[/en][ja]チュートリアル[/ja]",
            "link": "\/tutorial\/"
        },
        "nodes": [
            {
                "label": "[en]J-Node PFs Tutorial Catalogue[/en][ja]日本ノードＰＦチュートリアルカタログ[/ja]",
                "link": "\/tutorial\/pfs-catalogue\/"
            },
            {
                "label": "[en]Benham's Top[/en][ja]ベンハムの独楽[/ja]",
                "link": "/tutorial/benham/"
            },
            {
                "label": "[en]Semantic description of EEG[/en][ja]脳波データのSemantic Description[/ja]",
                "link": "\/tutorial\/semantic-eeg\/"
            }
        ]
    },
    {
        "root": {
            "label": "[en]Program[/en][ja]プログラム[/ja]",
            "link": "\/program\/nijc-program.html"
        },
        "nodes": [
            {
                "label": "[en]Neuroinformatics Platforms[/en][ja]プラットフォームの開発運営[/ja]",
                "link": "\/program\/platforms.html"
            },
            {
                "label": "[en]Research Data management with DOI[/en][ja]DOI によるデジタル研究データの管理[/ja]",
                "link": "\/program\/doi.html"
            }
        ]
    },
    {
        "root": {
            "label": "[en]Hackathon[/en][ja]ハッカソン[/ja]",
            "link": "\/program\/j-node-hackathon.html"
        },
        "nodes": [
            {
                "label": "J-Node Hackathon 2018",
                "link": "\/hackathon2018\/"
            },
            {
                "label": "Brainhack Global 2017",
                "link": "\/brainhack-global-2017\/"
            },
            {
                "label": "J-Node Hackathon 2016",
                "link": "\/hackathon2016\/"
            },
            {
                "label": "Brain Atlas Ideathon/Hackathon 2015",
                "link": "\/bah2015\/"
            }
        ]
    },
    {
        "root": {
            "label": "[en]Workshop AINI[/en][ja]国際ワークショップ AINI[/ja]",
            "link": "\/program\/workshop-aini.html"
        },
        "nodes": [
            {
                "label": "Advances in Neuroinformatics 2018",
                "link": "\/aini2018\/"
            },
            {
                "label": "Advances in Neuroinformatics 2017",
                "link": "\/aini2017\/"
            },
            {
                "label": "Advances in Neuroinformatics 2016",
                "link": "\/aini2016\/"
            },
            {
                "label": "Advances in Neuroinformatics 2015",
                "link": "\/aini2015\/"
            },
            {
                "label": "Advances in Neuroinformatics 2014",
                "link": "\/aini2014\/"
            }
        ]
    },
    {
        "root": {
            "label": "[en]Workshop NBNI[/en][ja]日中韓合同ワークショップ NBNI[/ja]",
            "link": ""
        },
        "nodes": [
            {
                "label": "NBNI 2017",
                "link": "\/nbni2017\/"
            },
            {
                "label": "NBNI 2014",
                "link": "\/nbni2014\/"
            }
        ]
    },
    {
        "root": {
            "label": "[en]Contact Us[/en][ja]問い合わせ[/ja]",
            "link": "\/contactus"
        },
        "nodes": []
    },
    {
        "root": {
            "label": "[en]Site Information[/en][ja]このサイトについて[/ja]",
            "link": "\/modules\/credits\/index.php"
        },
        "nodes": [
            {
                "label": "[en]Instructions for Use[/en][ja]ご利用上の注意[/ja]",
                "link": "\/modules\/credits\/index.php?id=1"
            },
            {
                "label": "[en]Copyrights[/en][ja]著作権について[/ja]",
                "link": "\/modules\/credits\/index.php?id=2"
            },
            {
                "label": "[en]Privacy Policy[/en][ja]個人情報の取扱いについて[/ja]",
                "link": "\/modules\/credits\/index.php?id=3"
            }
        ]
    }
]
